(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('MetaData', MetaData);

    /* @ngInject */
    function MetaData($resource) {
        var resourceUrl = 'api/metadata/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'getPermissions': {
                url: 'api/metadata/permissions',
                method: 'GET',
                isArray: true
            },
            'getPermissionMeta': {
                url: 'api/metadata/permission-meta',
                method: 'GET'
            },
            'get': {
                method: 'GET'
            },
            'save': {
                method: 'POST'
            },
            'update': {
                method: 'PUT'
            },
            'getDisplayOrder': {
                url: 'api/topics/settings',
                method: 'GET',
                isArray: true
            },
            'saveDisplayOrder': {
                url: 'api/topics/settings',
                method: 'PUT',
                isArray: true
            }
        });
    }
})();
